import { routeDirectory } from 'modules';
import { RouteObject } from 'react-router-dom';
import { AccessDeniedActivity } from './AccessDeniedActivity/AccessDeniedActivity';
import { RootActivity } from './RootActivity/RootActivity';
import { NoStoresActivity } from './NoStoresActivity/NoStoresActivity';



export const routes: RouteObject[] = [
  {
    path: routeDirectory.accessDenied.raw,
    element: <AccessDeniedActivity />
  },
  {
    path: '/',
    element: <RootActivity />
  },
  {
    path: routeDirectory.noStores.raw,
    element: <NoStoresActivity />
  }
];
